import { atom } from 'recoil';

import {
  Topic,
  TopicOwnerType,
  Message,
  PaginatedTemplates,
} from '../types/chats';
import { Paginated } from '../types/common';

export const chatTopicsState = atom<Paginated<Topic>>({
  default: {
    '@nextLink': '',
    count: 0,
    total: 0,
    value: [
      {
        app: 'user',
        content: '',
        createdAt: '',
        id: '',
        isPublic: true,
        messageTypeId: 'message',
        name: '',
        ownerId: '',
        ownerType: TopicOwnerType.USER,
        typeId: 'channel',
        unreadCount: 0,
        updatedAt: '',
      },
    ],
  },
  key: 'chatTopicsState',
});

export const chatTopicMessageState = atom<Partial<Paginated<Message[]>>>({
  default: {
    '@nextLink': '',
    count: 0,
    total: 0,
    value: [],
  },
  key: 'chatTopicMessageState',
});

export const messagesState = atom<Message[]>({
  default: [],
  key: 'chatMessagesState',
});

export const templatesState = atom<Partial<PaginatedTemplates>>({
  default: {
    '@nextLink': '',
    '@previousLink': '',
    count: 0,
    total: 0,
    value: [],
  },
  key: 'templatesState',
});

export const totalUnreadCountState = atom<number>({
  default: 0,
  key: 'totalUnreadCountState',
});
